import styled from '@emotion/styled'

export const Container = styled.main<{rtl: boolean}>`
  bottom: 0;
  ${props => props.rtl ? 'direction: rtl;' : ''}
  left: 0;
  overflow-y: scroll;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1001;
`
